import React, { useEffect, useState, useContext } from 'react';

import { useAuth } from '../../contexts/auth2';
import { Navigate,NavLink } from 'react-router-dom';

const Login = () => {
     const { login, signed } = useAuth();
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [loading, setLoading] = useState(false); // controle do botão
    const [rememberMe, setRememberMe] = useState(false);

    

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true); // ativa loading
        
        const payload = { email: email, password:password };

        try {
            await login(payload); // espera login (caso seja async)
        } catch (error) {
            alert('Erro ao logar');
            console.error("Erro ao logar:", error);
        } finally {
            setLoading(false); // garante que loading será desativado
        }

    }
    
    if(!signed){
        return (

            <div className='box-login'>
            <div className='box-login-1'>
                <div className='box-login-all'>
                    <form className="form-login" onSubmit={handleSubmit}>
                        <div className="bx-input"><img className='logo-login' src='./files/img/logo-1.svg'/></div>
                        <div className="bx-input"><h2>Seja bem-vindo(a)</h2></div>
                        <div className="bx-input"><span>Informe seus dados abaixo:</span></div>
                        <div className="bx-input">
                            <div style={{marginBottom: '7px',fontSize: '14px',marginTop: '25px'}}>E-mail</div>
                            <input 
                                className="inputs" 
                                name="email" 
                                type="text" placeholder="E-mail"
                                onChange={(e) => setEmail(e.target.value)}
                                />
                        </div>
                        <div className="bx-input">
                            <div style={{marginBottom: '7px',fontSize: '14px',marginTop: '15px'}}>Senha</div>
                            <input 
                                type="password" 
                                name="password" placeholder="Senha" autoComplete='off'
                                onChange={(e) => setPassword(e.target.value)}
                                />
                        </div>

                        <div className="d-flex">
                            <div className="bx-input" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <input
                                type="checkbox"
                                id="rememberMe"
                                name="rememberMe"
                                style={{width : 'auto'}}
                                checked={rememberMe}
                                onChange={(e) => setRememberMe(e.target.checked)}
                            />
                            <label htmlFor="rememberMe" style={{fontSize: '15px', margin: '0px 0px 0px 5px'}}>Lembrar-me</label>
                            </div>
                        
                            <div className="bx-input"><span><NavLink to="/forgot">Esqueci minha senha</NavLink></span></div>
                        </div>


                        <div className="bx-input">
                            
                            <button
                            className="btn btn-1"
                            type="submit"
                            disabled={loading}
                            >
                            {loading ? 'Entrando...' : 'Entrar'}
                            </button>
                        </div>

                        <div className="bx-input" style={{textAlign: 'center',margin: '20px 0px 0px 0px'}}><span>Ainda não possui conta? <NavLink to="/signup">Cadastre-se aqui</NavLink></span></div>

                    </form>
                </div>
            </div>
            <div className='box-login-2'><div className='bg-login-bg'></div></div>
            
        </div>
        );
    }else{
        return <Navigate to="/dashboard" />;
    }
}
export default Login;